
import { useNavigate } from 'react-router-dom'
import Typography from '@material-ui/core/Typography'

import ErrorLayout from 'components/layout/ErrorLayout'
import Link from 'components/Link'

const UnauthorizedView = () => {
  const navigate = useNavigate()
  return (
    <ErrorLayout title="Unauthorized" description="You are unauthorized to access the following page">
      <Typography
        align="center"
      >
        <Link to="" onClick={() => navigate(-1)}>
            Back
        </Link>
      </Typography>
    </ErrorLayout>
  )
}

export default UnauthorizedView
